// Module
var code = "<div> <iframe src=\"\"></iframe> </div> ";
// Exports
export default code;